import { render, staticRenderFns } from "./InterestIndex.vue?vue&type=template&id=f64e5266&"
import script from "./InterestIndex.vue?vue&type=script&lang=js&"
export * from "./InterestIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports